import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName } from '../utils'
import { loadCity, loadCourses, loadJuries, loadTalents } from '../utils/Network'
import { makeDarkSelectStyles } from './selectStyles';

export default function SelectIsFeatured({ callback, value, width ,name="is_featured",placeholder="Featured" }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = makeDarkSelectStyles({ width: width || '200px' });

    
    var options = [
        {
            label: "Featured",
            value: true
        },
        {
            label : "Not Featured",
            value : false
        },
    ]

    const handleSelect = (e) => {
        var value = e.value;
        callback(value, name)

    }

    return (
        <>
            <div className="filter-select">
                <Select options={options}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder}
                    value={options && options.filter(obj => obj.value == value)}


                />
            </div>
            
        </>
    )
}
